import { theme } from 'coreOld/themes';
import { CSSProperties } from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding-top: 20px;
  padding-bottom: 30px;
  margin-top: 20px;
  font-size: 25px;
  font-weight: 400;
  border-radius: 15px;

  background-color: ${({ theme }) => theme.colors?.actionBtn};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const LabelWrapper = styled.div`
  margin-bottom: 10px;
`;

export const InputWrapper = styled.div`
  width: 90%;
`;

export const controlStyle: CSSProperties = {
  height: 70,
  padding: '2px 40px 2px 25px',
};

export const iconStyle: CSSProperties = {
  height: 70,
  top: -20,
  fontSize: 26,
  margin: '0px 25px',
};

export const optionStyle: CSSProperties = {
  border: `1px solid ${theme.palette.backgrounds.border}`,
  borderTop: 'none',
  cursor: 'pointer',
  fontSize: 21,
  fontWeight: 300,
  letterSpacing: -0.6,
  padding: '20px 34px 22px',
  textAlign: 'left',
};

export const menuListStyle: CSSProperties = {
  maxHeight: 374,
};
